/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderIcon20Light = forwardRef('FolderIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4.5 8a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 3A1.5 1.5 0 0 0 2 4.5V14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H9.964a.5.5 0 0 1-.405-.206l-.855-1.176A1.5 1.5 0 0 0 7.49 3H3.5ZM3 4.5a.5.5 0 0 1 .5-.5h3.99a.5.5 0 0 1 .405.206l.856 1.176A1.5 1.5 0 0 0 9.964 6H15a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4.5Z" })));
});
